export default function getUTCDate(date = new Date()) {
  // new Date(argument) with no timezone information returns a UTC date
  return new Date(date.getTime());
}
